import styled from "styled-components";

export const Row = styled.tr`
  border-bottom: 1px solid #dddddd;
  width: 100%;
  display: table;
  table-layout: fixed;

  &:last-child {
    border-bottom: 2px solid lightgray;
  }
`;

export const TD = styled.td`
  padding: 3px;
  text-align: center;
  width: ${(props) => (props.width ? `${props.width}%` : "25%")};
`;
